module.exports = __webpack_public_path__ + "img/goodsD4.2fde7843.png";